var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5195 22.186C51.5195 17.009 49.4629 12.044 45.8022 8.38329C42.1415 4.72258 37.1765 2.66602 31.9995 2.66602C26.8225 2.66602 21.8575 4.72258 18.1968 8.38329C14.5361 12.044 12.4795 17.009 12.4795 22.186V23.5193C12.4795 33.3593 26.5595 49.7327 30.8795 60.5593C30.9666 60.7857 31.1202 60.9804 31.3202 61.1177C31.5201 61.255 31.7569 61.3285 31.9995 61.3285C32.242 61.3285 32.4789 61.255 32.6788 61.1177C32.8788 60.9804 33.0324 60.7857 33.1195 60.5593C37.4395 49.7327 51.5195 33.3593 51.5195 23.5193V22.186Z",
    fill: "#7C01FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.9e3527c4346fd0c50f42edf5d3dc64c9.svg";
export { ForwardRef as ReactComponent };